import { Injectable } from "@angular/core";
import { EGoogleTagEvents } from "../../enums/google-tag-manager-events.enum";

@Injectable()
export class GoogleTagManagerService {
  constructor() {
  }

  track(event: EGoogleTagEvents | string, extraOptions?: {}) {
    if (typeof window === 'undefined') return;

    const gtag = (window as any).gtag;
    if (typeof gtag !== 'function') {
      console.warn('[GTM] gtag not ready');
      return;
    }

    gtag('event', event, extraOptions);

    // if (typeof gtag !== 'undefined') {
    //   try {
    //     gtag('event', event, extraOptions);
    //   } catch (e) {
    //   }
    // }
  }
}
